import {User} from "./user";
import {Business} from "./business";

export class BusinessRight {
    id: number;

    member: User;

    business: Business;

    canAdministrate: boolean;

    canModerate: boolean;

    canCreate: boolean;

    avatarUrl: String;

    constructor(canCreate?, canAdministrate?, canModerate?) {
        this.canCreate = (canCreate!=null)?canCreate:false;
        this.canAdministrate = (canAdministrate!=null)?canAdministrate:false;
        this.canModerate = (canModerate!=null)?canModerate:false;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/business-right.ts